import { Component, ViewChild, ElementRef,HostListener, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext, WebResponesContext } from '../../../../model/common';
import{ NavController, ActionSheetController,AlertController,Events,IonTabs,MenuController,ModalController,Platform,PopoverController} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { Device } from '@ionic-native/device/ngx';
import { EmitserviceService } from 'src/service/emitservice.service';
import {WxjssdkService} from 'src/service/wxjssdk.service';
import {PublicselectionPage} from '../../../publicselection/publicselection.page';
import {SelectionpagePage} from '../../../selectionpage/selectionpage.page';
import {CodelessSalsePage} from '../../../codeless-salse/codeless-salse.page';
import { ListofActivitiesPage } from '../../listof-activities/listof-activities.page'
declare var app;
@Component({
  selector: 'app-scanning-homing',
  templateUrl: './scanning-homing.component.html',
  styleUrls: ['./scanning-homing.component.scss']
})
export class ScanningHomingComponent extends GridBaseCase implements AfterViewInit {

  @ViewChild('qrcode') qrcode: ElementRef;
  FK_TBActivity_ID: any = null;
  DisabledSubmit: boolean = false;
  isFormActivity:boolean = true;
  selectVal:any = null;
  milkActivity:any = null;
  tempGridList:Array<any>=new Array<any>();//礼品/样品列表
  tempGridgifList:Array<any>=new Array<any>();// 样品列表
  tempGridListless:Array<any>=new Array<any>();// 无码产品
  ischeckAll:boolean=false;//是否返回权限
  ischeckAllg:boolean=false; //是否 样品返回全选
  memInfo:any=null;//会员信息列表
  tempType1:boolean=true;//扫码销量
  tempType2:boolean=true;//无码扫描
  // logisticsCode:Array<string>=new Array<string>();//缓存罐码
  searchval:any;
  searchtex:any;
  type1:any;
  type1text:any;
  type2:any;
  type2text:any;
  type3:any;
  type3text:any;
  type4:any;
  type4text:any;
  activityID:any;//
  typeall:any=[];//所有用户标签
  a_TelPhone:any="";// 手机号
  checkTheSales:Boolean =false ; // 勾选销量是否提示不同语言
  afterPurchase:Boolean =true;
  thecluesErrmsg:any ="";// 提示语
  ntsType:string=""; // 角色
  GTBBSNumber:boolean=false; // GTBBS下是否有礼品选择
  activityListArray:Array<any> = new Array<any>();//活动名称列表
  activityName:any="请选择活动";
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService,
    public alertCtrl:AlertController,
    public modalCtrl:ModalController,
    public menuCtrl:MenuController,
    public actionSheetCtrl:ActionSheetController,
    public popoverCtrl:PopoverController,
    private alertController: AlertController,
    private barcode: BarcodeScanner,
    private device:Device,
    private emitService:EmitserviceService,
    private weixin:WxjssdkService
  ) { super(); 
    this.baseService.FixedSubmitBtn.configName = "ScanningHoming";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "确认下单";
    this.baseService.FixedSubmitBtn.type = 2;
    this.base.GridListCount=0;
    this.base.GridGiftCount=0;
    this.base.GridGiftNumber=0;
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
     this.activaRouter.queryParams.subscribe(queryParams => {
      console.log(queryParams,"rfegreg" )
            this.activityID= queryParams.FK_TBActivity_ID|| null; //互动ID
            this.activityName=queryParams.activityName|| null; //互动ID
          });
    const _id = this.activaRouter.snapshot.paramMap.get('id');
    console.log(_id)
    if(_id && _id.split("&")[0]){
      this.FK_TBActivity_ID = _id.split("&")[0];
      this.isFormActivity = true;
      if(_id.split("&")[1]){
        this.milkActivity = _id.split("&")[1];
      }
    }
    
  }

  ngAfterViewInit(){
  let that=this;
  console.log("yongh dadasd");
  that.ntsType=this.com.GetAccount.BuType||"";
  // that.tempGridList = that.com.GetStorageKey("homing");
      // that.base.GridGiftCount=that.tempGridList.length;
      console.log(that.com.GetStorageKey("homing"),"kkkk赠品数据")
      if(that.com.GetStorageKey("homing")){
          if(that.com.GetStorageKey("homing").length>0){
          that.GTBBSNumber = true;
         }
      }
      
  console.log(that.com.GetStorageKey("meminfo"))
      if(that.com.GetStorageKey("meminfo")){
        that.memInfo={};that.memInfo=that.com.GetStorageKey("meminfo");//获取会员信息列表
        console.log(that.memInfo)
        // that.memInfo["array"]=[];
        // if(that.memInfo["type1"] && that.memInfo["type1"].value){
        //   that.memInfo["array"].push(that.memInfo["type1"].text);
        // }
        // if(that.memInfo["type2"] && that.memInfo["type2"].value){
        //   that.memInfo["array"].push(that.memInfo["type2"].text);
        // }
        // if(that.memInfo["type3"] && that.memInfo["type3"].value){
        //   that.memInfo["array"].push(that.memInfo["type3"].text);
        // }
        // if(that.memInfo["type4"] && that.memInfo["type4"].value){
        //   that.memInfo["array"].push(that.memInfo["type4"].text);
        // }
        if(that.memInfo.type1){
          that.type1 = that.memInfo.type1.value;
          that.type1text = that.memInfo.type1.text;
        }
        
    if(that.memInfo.type2){
      that.type2 = that.memInfo.type2.value;
      that.type2text = that.memInfo.type2.text;
    }
        
      if(that.memInfo.type3){
        that.type3 = that.memInfo.type3.value;
        that.type3text = that.memInfo.type3.text;
      }
       
    if(that.memInfo.type4){
      that.type4 = that.memInfo.type4.value;
      that.type4text = that.memInfo.type4.text;
    }
        
        if(that.memInfo&&that.memInfo.typeall)
        {
          that.typeall=that.memInfo.typeall.value;
        }
        
        if(that.memInfo.a_TelPhone){
          that.a_TelPhone = that.memInfo.a_TelPhone.value;
        }
        if(that.memInfo.phones){
          that.a_TelPhone =that.memInfo.phones.value;
        }
      }
      // 勾选销量几次值
     that.afterPur();
     if( that.com.GetStorageKey("activityName")){
      that.activityName = that.com.GetStorageKey("activityName").activityName;
    }
    that.BindActivityInfo();
  }

  /**
   * 选择值
   * @param event 
   */
  changeSelect(event) {
    let that = this;
    console.log(event.detail.value);
    if (event.detail.value == "无") {
      this.FK_TBActivity_ID = null;
    } else {
      this.FK_TBActivity_ID = event.detail.value;
    }
    that.selectVal = "";
    this.baseService.ListData.forEach(item=>{
      item.isCheck = false;
      if(that.FK_TBActivity_ID == item.id){
        item.isCheck = true;
        that.selectVal = item.text;
      }
    })
    if(!that.selectVal){
      that.selectVal = "扫码销量";
    }
  }
  /**
   * 数量改变事件
   * @param item 
   */
  onInput(item) {
    console.log(item);
    this.baseService.FixedSubmitBtn["GridListCount"] = this.base.GridListCount;
  }
  /**
   * 礼品/样品值变化
   * @param item 
   */
  onInputChanage(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    // that.tempGridList.forEach(t=>{
    //   temoCount+=t.Num;
    // });
    e.target.value=item.Num;
    // that.base.GridGiftCount = temoCount;
  }
  /**
   * 
   * @param PageNumber 
   * 样品选择
   */
  onInputChanage1(item,e){
    const that =this;
    console.log(e,"值的变化");
    let _value="";
    if(e.target.value.trim()){
      _value=e.target.value;
    }else{
      _value="0";
    }
      item.Num=that.com.GetNumber(_value);
    let temoCount:number = 0;
    that.tempGridgifList.forEach(t=>{
      temoCount+=t.Num;
    });
    e.target.value=item.Num;
    that.base.GridGiftNumber = temoCount;
  }
  /**
   * 
   * 获取复选
   */
  afterPur(){
    const that =this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "CheckSalesVolume";
    body.OpType = "query";
    body.ConfigType = "Form";
    // body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    body.RequestBody={TelPhone:that.a_TelPhone};
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.msg.Loading("数据请求中...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        console.log(data);
        if(data.Status){
          that.checkTheSales =data.Status.IsRepurchaseAuthority;
          that.afterPurchase = data.Status.results;
           console.log( that.afterPurchase)
            that.thecluesErrmsg = data.Status.errorMessage;
            
        }
        
      } else {
        // console.log(data.ResponseMessage.ErrorMessage,"拉去活动列表失败");
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage)
    // console.log(error,"拉去活动列表失败");
    });
    loads.present();
  })
  }

  // 无码产品选择
  async codelessModal(){
    let that =this;
    console.log(that.afterPurchase)
    
    if(!that.afterPurchase){
      console.log("跳转")
      await that.msg.Alert(that.thecluesErrmsg).then(res=>{
        return;
       });
      return;
      
    }
    if(that.afterPurchase ){
      await that.msg.Alert(that.thecluesErrmsg).then(res=>{
       
      });
     }
     const modal = await that.modalCtrl.create({
      component: CodelessSalsePage,
      componentProps: {
        "typeItem": 1,
        "checkItem":that.base.GridArrayData
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if(data.result.ResponseMessage.Success){
      let tempList:Array<any>=new Array<any>();
            tempList=data.result.Status||[];
            that.tempGridListless=tempList;
            that.base.GridArrayData=[];
            that.tempGridListless.forEach(item => {
              let _data:any = {};
              _data["id"] = item.a_FK_TBProductInformation_ID||item.id;
              _data["name"] =item.b_ShortName|| item.name;
              _data["newMemberType"]="";
              _data["code"]=item.b_Code|| item.code;
              _data["IntegralCodeDetailList"]=new Array<any>();
              _data["num"] = item.Num || item.num;
              _data["type"] = 2;
              that.base.GridArrayData.push(_data);
            });
            that.base.GridListCount =that.base.GridArrayData.length;
            if(that.base.GridArrayData.length>0){
              if(that.base.GridArrayData.find(t=>t.type==1)){
                that.tempType1=true;
                 that.tempType2=false;
              }else{
                that.tempType1=false;
                that.tempType2=true;
              }
            }else{
                 that.tempType1=true;
                that.tempType1=true;
            }
            localStorage.setItem("product",JSON.stringify(that.base.GridArrayData));
   }
    console.log(data,"onWillDismiss");
   
  }
  LoadData(PageNumber) {
    let that = this;
    if(that.com.GetStorageKey("homing")){
      that.tempGridList = that.com.GetStorageKey("homing");
      // that.base.GridGiftCount=that.tempGridList.length;
    //   if(that.tempGridList.length>0){
    //     that.GTBBSNumber = false;
    // }
    }
    if(that.com.GetStorageKey("product")){
      that.base.GridArrayData=that.com.GetStorageKey("product");
      if( that.base.GridArrayData.length>0){
        if(that.base.GridArrayData.find(t=>t.type==1)){
          that.tempType1=true;
          that.tempType2=false;
        }else{
          that.tempType1=false;
          that.tempType2=true;
        }
      }else{
        that.tempType1=true;
        that.tempType2=true;
      }
      that.base.GridListCount=that.base.GridArrayData.length;
    }
  }
  /**
   * 确认下单
   */
  EventClick() {
    const that = this;
    console.log("扫描归巢");
    that.DisabledSubmit = true;

    if (that.base.GridArrayData.length <= 0 && that.tempGridList.length<=0) {
      that.msg.Alert("请选择产品或者赠品");
      that.baseService.FixedSubmitBtn.isSubmitData = true;
      return;
    }
    if(that.base.GridArrayData.length > 0 && that.tempGridList.length>0 ){
      // if(that.base.GridArrayData.filter(item=>item.newMemberType=="4")){
      //   that.msg.Alert("勾选礼品无效请重新勾选");
      //   return;
      // }
      if(that.base.GridArrayData.find(item=>item.newMemberType=="4")){
        that.msg.Alert("勾选礼品无效请重新勾选");
         return;
      }
    }
  
        that.EventClickBefore().then(data=>{
          that.msg.Confirm("确认下单吗？","取消","确定","",false).then(res=>{
            if(res){
              that.msg.Loading("数据请求中...").then(loads=>{
                data.Status.ConfigName="ProductPurchase";
                that.http.post(app.DEFAULTURL, data.Status).then(data => {
                  that.baseService.FixedSubmitBtn.isSubmitData = true;
                  that.DisabledSubmit = false;
                  loads.dismiss();
                  /****判断是否第一页end****/
                  if (data.ResponseMessage.Success) {
                    that.base.GridArrayData = new Array<any>();
                    that.base.GridListCount = 0;
                    console.log(data);
                   
                     
                    let _url:Array<string> = new Array<string>();
                  
                    if(that.com.GetStorageKey("backurl")){
                      _url.push(that.com.GetStorageKey("backurl")[0]);
                    }
                     that.com.removeItem(["homing","product","meminfo","backurl","lpArrayList","activityName"]);
                      localStorage.setItem("backurl",JSON.stringify(_url));
                       that.msg.Alert("下单成功").then(res=>{
                        that.com.goBack();
                       });
                  } else {
                    that.msg.Alert(data.ResponseMessage.ErrorMessage);
                  }
                }).catch(error => {
                  that.baseService.FixedSubmitBtn.isSubmitData = true;
                  loads.dismiss();
                  that.DisabledSubmit = false;
                  console.log(error);
                  that.msg.Alert(error.ResponseMessage.ErrorMessage);
                });
                  loads.present();
                  });
            }
          });
        }).catch(err=>{
          that.msg.Confirm("确认下单吗？","取消","确定","",false,true).then(res=>{
            if(res){
            }
          });
        });
    
  }
    /**
   * 确认下单之前判断
   */
  EventClickBefore(): Promise<WebResponesContext>{
    const that = this;
    console.log("扫描归巢");
       
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let  respone:WebResponesContext=new WebResponesContext();
     
      let DataList: Array<any> = new Array<any>();
      let lpArray:Array<any>=new Array<any>();//礼品列表
     //#region 产品列表
      that.base.GridArrayData.forEach(item => {
        let array = {};
        array["a_FK_TBProductInformation_ID"] = item.id;
        array["a_Num"] = item.num;
        array["a_productCode"] = item.code;
        // array["a_FK_TBActivity_ID"] = that.FK_TBActivity_ID;
        array["IntegralCodeDetailList"]=item.IntegralCodeDetailList;
        DataList.push(array);
      });
      // that.tempGridListless.forEach(item=>{
      //   let array = {};
      //   array["a_FK_TBProductInformation_ID"] = item.id;
      //   array["a_Num"] = item.num;
      //   array["a_productCode"] = item.code;
      //   array["a_FK_TBActivity_ID"] = that.FK_TBActivity_ID;
      //   array["IntegralCodeDetailList"]=item.IntegralCodeDetailList;
      //   DataList.push(array);
      // })

     //#endregion
      //#region  礼品
        that.tempGridList.forEach(p=>{
          let c:any={};
          c["id"]=p.id;
          c["Stock"]=p.Stock;
          c["Code"]=p.Code;
          c["Num"]=p.Num;
          lpArray.push(c);
        });
      //#endregion
      // debugger;
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName = "CheckProductPurchase";
  body.OpType = "add";
  body.ConfigType = "view";
  body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = 0;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  let _obj={"giftData":lpArray,"productData":DataList,"memberID":null,"OrderEntry":"1"};
  if(that.com.GetStorageKey("meminfo")){
    _obj["memberID"]= that.com.GetStorageKey("meminfo")["id"].value;
  }
  _obj["a_FK_TBActivity_ID"]= that.activityID;//活动ID
  _obj["telphone"] =  that.a_TelPhone;

  
  body.RequestBody = JSON.stringify(_obj);
 
  respone.Status=body;
  respone.ResponseMessage.Success=true;
  respone.ResponseMessage.ErrorMessage="";
      that.msg.Loading("数据请求中...").then(loads=>{
        that.http.post(app.DEFAULTURL, body).then(data => {
          loads.dismiss();
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
            resolve(respone);
          } else {
            respone.ResponseMessage.Success=false;
            respone.ResponseMessage.ErrorMessage=data.ResponseMessage.ErrorMessage;
            reject(respone);
          }
        }).catch(error => {
          respone.ResponseMessage.Success=false;
          respone.ResponseMessage.ErrorMessage="系统异常请联系管理员";
          reject(respone);
        });
          loads.present();
      });
    });
  }
  qrCodeClick(){
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id');
    that.presentAlertCheck(PageName);
  }

  async presentAlertCheck(PageName) {
    const that = this;
    let isplatform:boolean = false;
     if(that.platform.is("cordova")){
      if(that.platform.is("android")){
        if(that.device.version){
          if(that.device.version.toString().startsWith("4")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("3")){
            isplatform=true;
          }else if(that.device.version.toString().startsWith("2")){
            isplatform=true;
          }
        }
      }
     };
     if(that.com.IsWeixinBrowser){//如果是微信客户端调用微信
      isplatform=false;
     }
     if(isplatform){
      if(window.confirm("请选择扫码方式,【确定】表示扫码,【取消】表示手动输入")){
        that.com.setHistoryUrl();
        that.scanQrcode(PageName);
       }else{
        var code= window.prompt("请输入产品罐码/箱码","");
        if(code){
          let _obj = {};
          _obj["Code"] = code;
          if(that.ntsType == "GTBBS"){
            _obj["IsGift"] =that.GTBBSNumber
            
          }
          that.LoadDataBind(_obj);
        }else{
          that.msg.Alert("编码不能为空！");
        }
       }
     }else{
      const alert = await this.alertController.create({
        header: '系统提示',
        message:"请选择方式",
        mode:"ios",
        cssClass:"more-btn",
        buttons: [
          {
            text: "扫码识别",
            cssClass: 'btn-okay btn-width',
            handler: (Okay = "1") => {
              // console.log(Okay,"ok");
              // that.com.setHistoryUrl();
              that.scanQrcode(PageName);
            }
          },
          {
            text: "手动输入",
            cssClass: 'btn-okay btn-width',
            handler: (Okay1 = "2") => {
              // console.log(Okay1,"ok1");
              that.presentAlertInput();
            }
          },
          {
            text: "取消",
            role: 'cancel',
            cssClass: 'secondary btn-cancel btn-width',
            handler: (cancel) => {
              console.log(cancel,"cancel");
            }
          }
        ]
      });
      await alert.present();
     }
  }


  async presentAlertInput() {
    const that = this;
    const alert = await this.alertController.create({
      header: '请输入产品罐码/箱码',
      mode:"ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入产品罐码/箱码',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        },
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"]) {
              let _obj = {};
              _obj["Code"] = Okay["a_Code"];
              if(that.ntsType== "GTBBS"){
                _obj["IsGift"] =that.GTBBSNumber
              }
              that.LoadDataBind(_obj);
            } else {
              that.msg.Alert("编码不能为空！");
            }

          }
        }
        
      ]
    });

    await alert.present();
  }
    /**
   * 扫码
   * @param PageName 
   */
  scanQrcode(PageName) {
    const that = this;

    if (that.platform.is('cordova')) {
      // that.com.setHistoryUrl();
      that.barcode.scan().then((scan) => {
        let sancanArray: Array<any> = new Array<any>();
        sancanArray = that.com.GetStorageKey("backurl") || [];
        sancanArray.splice(sancanArray.length - 1, 1);
        localStorage.setItem("backurl", JSON.stringify(sancanArray));
        if (PageName) {
          if (PageName == "ScanCodeSales") {
            let _obj = {};
            if(scan.text){
              _obj["Code"] = scan.text;
              if(that.ntsType== "GTBBS"){
                _obj["IsGift"] =that.GTBBSNumber
              }
              that.LoadDataBind(_obj);
            }
          }
        }
      }).catch(error => {
        that.msg.Show(error);
      });
    } else {
      if(that.com.IsWeixinBrowser){
        that.weixin.GetWxScanQRCode().then(data=>{
          // alert("扫码销量");
          let _obj = {};
            _obj["Code"] = data.Status;
            console.log(JSON.stringify(_obj),"返回二维码编码");
            // alert(JSON.stringify(_obj));
            if(that.ntsType== "GTBBS"){
              _obj["IsGift"] =that.GTBBSNumber
            }
            that.LoadDataBind(_obj);
        }).catch(err=>{
          that.msg.Show(err.ResponseMessage.ErrorMessage, "middle");
        });
      }else{
        that.msg.Show("暂不支持", "middle");
      }
    }
  }
  LoadDataBind(obj: any) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
        body.ConfigName = "ScanCodeXML";// "TBProductInformationXML";//产品名称
        body.OpType = "query";
        body.ConfigType = "view";
        body.RowsPerPage = app.RowsPerPage;
        body.PageNumber = 1;
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = "element";
        body.Client.ClientType = 2;
        body.SpecialParameter=1;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }
        body.RequestBody = JSON.stringify(obj);
    console.log(body,"请求接口");
    that.msg.Loading("数据请求中...").then(loads=>{
      that.http.post(app.DEFAULTURL, body).then(data => {
        // console.log("data数据数据888888");
        // console.log("data数据数据888888",data);
        loads.dismiss();
        if (data.ResponseMessage.Success) {
  
          let isproduct: boolean = false;
          if(that.base.GridArrayData.length>0){
            that.base.GridArrayData.forEach(t=>{
              if(t.IntegralCodeDetailList){
                t.IntegralCodeDetailList.forEach(g=>{
                  // if(g.LogisticsCode == obj.Code || g.BoxBarcode==obj.code){
                  //   isproduct = true;
                  // }
                  if(obj.Code.indexOf(g.LogisticsCode)!=-1 || obj.Code.indexOf(g.BoxBarcode)!=-1){
                     isproduct = true;
                   }
                });
              }
            });
          }else{

          }
          if (isproduct) {
            that.msg.Alert("已录入，请勿重复录入");
            return;
          } 
          // 判断箱码罐码的数量对于否的弹窗
          if(data.Status.ResultCode === 3){
            that.msg.Confirm(`当前产品的扫描数量（${data.Status.IntegralCodeDetailList.length}听/罐）与实际箱规数量（${data.Status.boxCount}听/罐）不一致，是否按照实际箱规数量进行下单?`,"取消","确定").then(fit=>{
              if(fit){
                let _data = {};
                _data["id"] = data.Status.productId;
                _data["name"] = data.Status.shortName||data.Status.productname;
                _data["num"] = data.Status.Count;
                _data["code"] = data.Status.productCode;
                _data["newMemberType"]=data.Status.newMemberType||"0";
                _data["type"] =1;
                _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
                let isproductnum: boolean = false;
                that.base.GridArrayData.forEach(item => {
                  if (item.id == data.Status.productId) {
                    data.Status.IntegralCodeDetailList.forEach(items => {
                      item.IntegralCodeDetailList.push(items);
                    });
                    let coun1: number = item.num;
                    let count2: number = data.Status.Count;
                    let count3: number = coun1 + count2;
                    item.num = count3;
                    isproductnum = true;
                  }
                });
                if (!isproductnum) {
                  that.base.GridArrayData.push(_data);
                }
                let sumNum: number = data.Status.Count;
                that.base.GridListCount += sumNum;
                localStorage.setItem("product",JSON.stringify(that.base.GridArrayData));
                console.log(that.base.GridArrayData,"处理完毕");
                if( that.base.GridArrayData.length>0){
                  console.log(that.base.GridArrayData.length);
                  if(that.base.GridArrayData.find(t=>t.type==1)){
                  
                    that.tempType1=true;
                    that.tempType2=false;
                    console.log(that.tempType1)
                    console.log(that.tempType2)
                  }else{
                    that.tempType1=false;
                    that.tempType2=true;
                  }
                }else{
                  that.tempType1=true;
                  that.tempType2=true;
                }
              }else{return;}
            })
          }else{
            let _data = {};
            _data["id"] = data.Status.productId;
            _data["name"] = data.Status.shortName||data.Status.productname;
            _data["num"] = data.Status.Count;
            _data["code"] = data.Status.productCode;
            _data["newMemberType"]=data.Status.newMemberType||"0";
            _data["type"] =1;
            _data["IntegralCodeDetailList"] = data.Status.IntegralCodeDetailList;
            let isproductnum: boolean = false;
            that.base.GridArrayData.forEach(item => {
              if (item.id == data.Status.productId) {
                data.Status.IntegralCodeDetailList.forEach(items => {
                  item.IntegralCodeDetailList.push(items);
                });
                let coun1: number = item.num;
                let count2: number = data.Status.Count;
                let count3: number = coun1 + count2;
                item.num = count3;
                isproductnum = true;
              }
            });
            if (!isproductnum) {
              that.base.GridArrayData.push(_data);
            }
            let sumNum: number = data.Status.Count;
            that.base.GridListCount += sumNum;
            localStorage.setItem("product",JSON.stringify(that.base.GridArrayData));
            console.log(that.base.GridArrayData,"处理完毕");
          }
          if( that.base.GridArrayData.length>0){
            console.log(that.base.GridArrayData.length);
            if(that.base.GridArrayData.find(t=>t.type==1)){
            
              that.tempType1=true;
              that.tempType2=false;
              console.log(that.tempType1)
              console.log(that.tempType2)
            }else{
              that.tempType1=false;
              that.tempType2=true;
            }
          }else{
            that.tempType1=true;
            that.tempType2=true;
          }
          that.base.GridListCount=that.base.GridArrayData.length; 
        } else {
          if (data.ResponseMessage.ErrorMessage) {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
          } else {
            that.msg.Alert("该编码不存在！");
          }
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      })
      loads.present();
    })
  }


  // 礼品弹窗
  async presentModal1() {
    console.log("fnengnkrwngnkwnbgr");
    let that = this;
    let ids:Array<string>=new Array<string>();
    if(that.base.GridArrayData.length<=0){
      that.msg.Alert("请先操作【扫码销量】");
      return;
    }
    that.base.GridArrayData.forEach(item => {
     
      console.log(item.id)
      ids.push(item.id);
      console.log("item.id--------------------------")
    });
   let checkitem:Array<string>=new Array<string>();
      that.tempGridList.forEach(temp=>{
        checkitem.push(temp.id);
        console.log("checkitem++++++++++++++++++")
        console.log(checkitem)
      });
    const modal = await that.modalCtrl.create({
      component: PublicselectionPage,
      componentProps: {
        "ids": ids,
        "checkItem":checkitem,
        "checked":that.ischeckAll
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    if(data.result.ResponseMessage.Success){
       let tempList:Array<any>=new Array<any>();
            tempList=data.result.Status;
            that.ischeckAll=data.checked;
      // let tempList:Array<any>=new Array<any>();
      // let resulttemp:Array<any>=new Array<any>();
      //   tempList=data.result.Status;
      //   resulttemp=that.tempGridList;
      //   if(tempList.length>0 ){
      //     if(that.tempGridList.length>0){
      //       tempList.forEach(item=>{
      //         if(that.tempGridList.findIndex(p=>p.id==item.id)==-1){
      //           resulttemp.push(item);
      //         }
      //       });
      //     }else{
      //       resulttemp=tempList;
      //     }
      //   }
        that.base.GridGiftCount=0;
        that.tempGridList=tempList;
        // that.tempGridList.forEach(po=>{
        //   that.base.GridGiftCount+=po.Num;
        // });
    }
    console.log(data,"onWillDismiss");
  }
  /**
   * 样品选择弹窗
   */
  async seletionModal() {
    console.log("样品选择");
    let that = this;
    let ids:Array<string>=new Array<string>();
    if(that.base.GridArrayData.length<=0){
      that.msg.Alert("请先操作【扫码销量】");
      return;
    }
    that.base.GridArrayData.forEach(item => {
      ids.push(item.id);
    });
    let checkitem:Array<string> = new Array<string>();
    that.tempGridgifList.forEach(itemp =>{
      checkitem.push(itemp.id);

    })
    const modal = await that.modalCtrl.create({
      component: SelectionpagePage,
      componentProps: {
        'ids': ids,
        "checkItem":checkitem,
        "checked":that.ischeckAllg
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    console.log(data,"onWillDismiss");
    if(data.result.ResponseMessage.Success){
      let tempgiftList:Array<any> = new Array<any>();
      tempgiftList = data.result.Status;
      that.ischeckAllg = data.checked;
      that.base.GridGiftNumber=0;
      that.tempGridgifList=tempgiftList;
      that.tempGridgifList.forEach(po=>{
        that.base.GridGiftNumber+=po.Num;
      });
    }
  }



  /**
   * 删除
   */
  presentActionShee(itmid,index){
    const that = this;

    that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
      if(fit){
        if(that.base.GridArrayData.length >0){
          that.base.GridArrayData.splice(index,1);
          localStorage.setItem("product",JSON.stringify(that.base.GridArrayData));
          // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
        }
        if( that.base.GridArrayData.length>0){
          if(that.base.GridArrayData.find(t=>t.type==1)){
            that.tempType1=false;
            that.tempType1=true;
          }else{
            that.tempType1=true;
            that.tempType1=false;
          }
        }else{
          that.tempType1=true;
          that.tempType2=true;
        }
        that.base.GridListCount=that.base.GridArrayData.length;
      }
    });  
    }
  /**
   * 底部弹出删除
   */
  async presentActionSheet(item,index) {
    const that=this;
    const actionSheet = await this.actionSheetCtrl.create({
      // header: 'Albums',
      buttons: [{
        text: '删除',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          if(that.base.GridArrayData.length >0){
            // // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
            // if(that.base.GridArrayData[index]){
            //      if(that.base.GridArrayData[index].IntegralCodeDetailList){
            //       that.base.GridArrayData[index].IntegralCodeDetailList.forEach(cp=>{
            //         let hi=that.base.IntegralCodeDetailList.length;
            //         while(hi--){
            //           if(that.base.IntegralCodeDetailList[hi]==cp.LogisticsCode){
            //             that.base.IntegralCodeDetailList.splice(hi,1);
            //           }
            //         }
            //       });
            //      }
            // }
            that.base.GridArrayData.splice(index,1);
            localStorage.setItem("product",JSON.stringify(that.base.GridArrayData));
            // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
          }
      if( that.base.GridArrayData.length>0){
        if(that.base.GridArrayData.find(t=>t.type==1)){
          that.tempType1=false;
          that.tempType1=true;
        }else{
          that.tempType1=true;
          that.tempType1=false;
        }
      }else{
        that.tempType1=true;
        that.tempType2=true;
      }
          that.base.GridListCount=that.base.GridArrayData.length;
        }
      }, 
      {
        text: '取消',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }
  /**
   * 
   * @param itmid 无码删除
   * @param index 
   */
  presentActionSheeless(itmid,index){
    const that = this;

    that.msg.Confirm("确定删除吗?","取消","确定").then(fit=>{
      if(fit){
        if(that.tempGridListless.length >0){
          // that.tempGridList = that.tempGridList.filter(item => item.id !== itmid);
          that.tempGridListless.splice(index,1);
          if(that.com.GetStorageKey("homing")){
            localStorage.setItem("homing",JSON.stringify(that.tempGridListless));
          }
          // that.tempGridList=that.tempGridList.splice( that.tempGridList.findIndex(item => item.id ==itmid), 1); 
        }
      }
    });

     
    }
     /**
   * 获取活动列表
   */
      BindActivityInfo(){
        const that =this;
        that.activityListArray=[];
        const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
        let body = new WebParameterContext();
        body.Account = that.com.GetAccount;
        body.ConfigName = "GetActivityList";
        body.OpType = "query";
        body.ConfigType = "form";
        // body.RowsPerPage = app.RowsPerPage;
        body.PageNumber = 0;
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = that.element.name;
        body.Client.ClientType = 0;
        console.log(that.a_TelPhone)
        // body.RequestBody={"telPhone":that.a_TelPhone};
        // let _obj={};
        // _obj["telPhone"] = that.a_TelPhone;
        // body.RequestBody = JSON.stringify(_obj);
        body.RequestBody = JSON.stringify({"telPhone": that.a_TelPhone})
        that.http.post(app.DEFAULTURL, body).then(data => {
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
           that.activityListArray=data.Status.Datas||[];
          } else {
            console.log(data.ResponseMessage.ErrorMessage,"拉去活动列表失败");
          }
        }).catch(error => {
        console.log(error,"拉去活动列表失败");
        });
      }
    async presentModaldifferences() {
      var that=this;
      // debugger;
      let _id="";
      if( that.com.GetStorageKey("activityName")){
        _id = that.com.GetStorageKey("activityName").activityID;
      }
      if(that.activityID){
        _id= that.activityID;
      }
      
      const modal = await this.modalCtrl.create({
        component: ListofActivitiesPage,
        cssClass: 'listof-activities',
        componentProps: {
          "type":"扫码归巢",
          "activityListArrayList":that.activityListArray, 
          "activeID":_id
        }
      });
        await modal.present();
      const { data } = await modal.onWillDismiss();
      console.log(data)
      if(data.seceltName){
        that.activityName = data.seceltName;
        that.activityID = data.FK_TBReasonsProductInventoryDifferences_ID;
        
        if( that.activityName!==that.com.GetStorageKey("activityName")){
          // that.tempGridList= [];
          that.com.removeItem(["activityName"]); 
        }
        let _obj = {
          activityName:that.activityName,
          activityID:that.activityID
        }
        localStorage.setItem("activityName",JSON.stringify(_obj));
      }
      console.log(data.cravingforRemk)
     console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
    }
    // 清楚选择的活动
    cleashideModal(){
      const that=this;
      that.activityName ="请选择活动";
      // that.tempGridList= [];
      that.activityID ="";
      that.com.removeItem(["activityName"]); 
    }
}
